import React from 'react';
import Button from '../../../../../components/Button';
import * as S from './styles';
import { moneyFormat } from '../../../../../utils/formatters';
import TagInfo from '../../../../../components/TagInfo';
import { IconWarningBlue } from '../../../../../components/IconWarningBlue';
import { ServiceItemProps } from '../../../../../models/Service';
import { ProductItemProps } from '../../../../../models/Product';
import ContainerPage from '../../../../../components/ContainerPage';
import ResourceIcon from '../components/ResourceIcon';

export type ServiceItemAddCartProps = {
  product?: ProductItemProps;
  handleAddProductList: ({
    product,
    service
  }: {
    product: ProductItemProps | undefined;
    service: ServiceItemProps | undefined;
  }) => void;
  onClose?: () => void;
  titleMainButton?: string;
  service?: ServiceItemProps;
  titleSecondaryButton?: string;
};

const ServiceItemAddCart = ({
  handleAddProductList,
  onClose,
  product,
  titleMainButton,
  service,
  titleSecondaryButton
}: ServiceItemAddCartProps) => {
  const showPrices = !service && !product?.is_b2b;

  return (
    <ContainerPage
      childrenFooter={
        <>
          <Button
            title={!titleMainButton ? 'Adicionar' : titleMainButton}
            onClick={() => {
              if (product) {
                product.quantity = 1;
                handleAddProductList({ product, service: undefined });
              }
              if (service) {
                handleAddProductList({ product: undefined, service });
              }
            }}
          />
          <S.CloseWrapper>
            <Button title={titleSecondaryButton ? titleSecondaryButton : 'Fechar'} tertiary onClick={onClose} />
          </S.CloseWrapper>
        </>
      }
    >
      <S.InfoContainer>
        <S.HeadWrapper>
          <ResourceIcon productIconName={product?.icon} serviceName={service?.name} />
          <S.ProductName>{product?.name || service?.name}</S.ProductName>
        </S.HeadWrapper>
        <S.BodyWrapper>
          <S.GridContador>
            <S.DescriptonServiceItem>{product?.description || service?.description}</S.DescriptonServiceItem>
            {showPrices && (
              <>
                <S.WrapperInfo>
                  <TagInfo
                    info="O agendamento por este canal é somente particular. Para informações de convênios entre em contato com a central de atendimento."
                    icon={<IconWarningBlue />}
                  />
                </S.WrapperInfo>
                <S.Actions>
                  <S.Price>{product?.price && moneyFormat(Number(product?.price).toString())}*</S.Price>
                </S.Actions>
              </>
            )}
          </S.GridContador>
          {showPrices && <S.Info>*Para atendimento em domicílio os valores podem sofrer alterações.</S.Info>}
        </S.BodyWrapper>
      </S.InfoContainer>
    </ContainerPage>
  );
};
export default ServiceItemAddCart;
